<script setup>
import { ref, reactive, computed, onMounted, defineComponent, defineExpose } from 'vue'
import { showToast, Picker, Popup, DatePicker } from 'vant';
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getUserRoleAPI, getWayListAPI, getPayNapeAPI, createOrderAPI,
  payComfigAPI, getRemarkInfoAPI, getAllPaymentAPI } from '@/util/api'
import fl1 from "@/assets/img/03p/fl1.png"
import fl2 from "@/assets/img/03p/fl2.png"
import fl3 from "@/assets/img/03p/fl3.png"
import fl4 from "@/assets/img/03p/fl4.png"
import fl5 from "@/assets/img/03p/fl5.png"
import fl6 from "@/assets/img/03p/fl6.png"
import fl7 from "@/assets/img/03p/fl7.png"

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
const ElementPicker = defineComponent(Picker)
const ElementPopup = defineComponent(Popup)
const ElementDatePicker = defineComponent(DatePicker)

const flArr = ref([
  { flIcon: fl1 },
  { flIcon: fl2 },
  { flIcon: fl3 },
  { flIcon: fl4 },
  { flIcon: fl5 },
  { flIcon: fl6 },
  { flIcon: fl7 },
])
let isWait = ref(false)
const timeOut1 = ref(null)
const count1 = ref(60)
const roleData = ref('')
const showQufu = ref(false)
const activeRole = ref('')
const payWayList = ref('')
const payNapeList = ref('')
const payParams = ref({
  pgid: 59,
  pid: 45,
  gid: 1000796,
  duid: "",
  dsid: "",
  dsname: "",
  drid: "",
  drname: "",
  uid: "",
  uname: "",
  token: "",
  money: "",
  pway: "",
  paycode: '',
  pay_type: "game",
  rechargeid: "", // 充值挡位id
  coin: "", // 挡位游戏币(砖石)
  rebate: "", // 返利百分比(小数)
  accountid: "", // 研发账号id
  roleid: "", // 角色id
})
const showPayWayPop = ref(false)
const payNavIndex = ref('1')
const remarkInfo = ref('')
const recordParams = ref({
  uid: '',
  uname: '',
  pgid: '',
  stime: '',
  etime: '',
  drid: '',
  dsid: ''
})
const showStartTime = ref(false)
const minDate = ref(new Date(2023, 0, 1))
const maxDate = ref(new Date())
const currentDate = ref(['2025', '10', '01'])
const showEndTime = ref(false)
const tableData = ref('')
const showQufu2 = ref(false)
const activeRole2 = ref('')

const getUserRole = () => {
  const reqData = {
    pgid: '59',
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token 
  }
  getUserRoleAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      roleData.value = res.data.data
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const onConfirmRole = (value) => {
  console.log('【选择区服】', value);
  activeRole.value = value.selectedOptions[0]
  showQufu.value = false
}
const onChangeRole = (value) => {
  console.log('【切换】', value);
  
}
const getWayList = () => {
  getWayListAPI(getReqData({ pgid: 59 })).then(res => {
    if (res.data.code == 0) {
      console.log('【支付列表】', res.data.data);
      payWayList.value = res.data.data
      payWayList.value.forEach((ele) => {
        if (ele.checked == 1) {
          payParams.value.pway = ele.type
          payParams.value.paycode = ele.paycode
        }
      })
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const getPayNape = () => {
  getPayNapeAPI(getReqData({ pgid: 59, pay_type: "game" })).then(res => {
    if (res.data.code == 0) {
      console.log('【档位列表】', res.data.data.list);
      payNapeList.value = res.data.data.list
      payNapeList.value.forEach((ele) => {
        if (ele.checked) {
          payParams.value.money = ele.money;
          payParams.value.rechargeid = ele.productid;
          payParams.value.rebate = ele.rebate;
          payParams.value.coin = ele.coin;
        }
      });
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const checkPayNape = (nape) => {
  payNapeList.value.forEach((ele) => {
    ele.checked = 0
  });
  nape.checked = 1
  payParams.value.money = nape.money;
  payParams.value.rechargeid = nape.productid;
  payParams.value.rebate = nape.rebate;
  payParams.value.coin = nape.coin;
}
const goPay = () => {
  if (!activeRole.value.dsid) {
    showToast({ type: 'fail', message: '서버 선택', className:'toast-fail' })
    return
  }
  console.log('【去选择支付】');
  
  showPayWayPop.value = true
}
const createOrder = (value) => {
  payParams.value.pway = value.selectedOptions[0].type
  payParams.value.paycode = value.selectedOptions[0].paycode
  payParams.value.uid = userInfo.value.uid
  payParams.value.uname = userInfo.value.uname
  payParams.value.token = userInfo.value.token
  payParams.value.dsid = activeRole.value.dsid
  payParams.value.dsname = activeRole.value.dsname
  payParams.value.drid = activeRole.value.drid
  payParams.value.drname = activeRole.value.drname
  createOrderAPI(getReqData(payParams.value)).then(res => {
    if (res.data.code == 0) {
      console.log('【下单接口】', res.data.data);
      payComfig(payParams.value, res.data.data.moid)
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const payComfig = (data, moid) => {
  let reqData = data
  reqData.moid = moid
  reqData.pdata = ''
  payComfigAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      console.log('【档位列表】', res.data.data);
      window.location.href = res.data.data.trade
      showPayWayPop.value = false
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}

const getRemarkInfo = () => {
  getRemarkInfoAPI().then(res => {
    if (res.data.code == 0) {
      remarkInfo.value = res.data.data
      console.log('【remarkInfo】', remarkInfo);
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const goCustomer = () => {
  if (localStorage.getItem('config-record')) {
    window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
  }
}
const confirmStart = (date) =>{
  console.log('【开始时间】', date);
  const dateType = date.selectedValues[0] + '-' + date.selectedValues[1] + '-' + date.selectedValues[2]
  if (recordParams.value.etime && (new Date(recordParams.value.etime) < new Date(dateType))) {
    recordParams.value.stime = recordParams.value.etime
    recordParams.value.etime = dateType
  } else {
    recordParams.value.stime = dateType
  }
  console.log('【视角】', new Date(dateType));
  showStartTime.value = false
}
const confirmEnd = (date) =>{
  console.log('【开始时间】', date);
  const dateType = date.selectedValues[0] + '-' + date.selectedValues[1] + '-' + date.selectedValues[2]
  if (recordParams.value.stime && (new Date(recordParams.value.stime) > new Date(dateType))) {
    recordParams.value.etime = recordParams.value.stime
    console.log('【recordParams.value.etime】', recordParams.value.etime);
    recordParams.value.stime = dateType
    console.log('【recordParams.value.stime', recordParams.value.stime);
  } else {
    recordParams.value.etime = dateType
  }
  showEndTime.value = false
}
const getAllPayment = () => {
  recordParams.value.uid = userInfo.value.uid
  recordParams.value.uname = userInfo.value.uname
  recordParams.value.pgid = 59
  if (activeRole2.value) {
    recordParams.value.drid = activeRole2.value.drid
    recordParams.value.dsid = activeRole2.value.dsid
  } else {
    recordParams.value.drid = ''
    recordParams.value.dsid = ''
  }
  getAllPaymentAPI(getReqData(recordParams.value)).then(res => {
    if (res.data.code == 0) {
      tableData.value = res.data.data
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const onConfirmRecordRole = (value) => {
  console.log('【选择区服】', value);
  activeRole2.value = value.selectedOptions[0]
  console.log('【activeRole2】', activeRole2);
  
  showQufu2.value = false
}

const delayedCode = () => {
  if (count1.value > 0) {
    timeOut1.value = setTimeout(() => {
      count1.value--
      delayedCode()
    }, 1000)
  } else {
    clearTimeout(timeOut1.value)
    isWait.value = false
    count1.value = 60
  }
}

const joinFb = () => {
  // childRef3.value.updateTaskStatus(3)
}
const joinDs = () => {
  // childRef3.value.updateTaskStatus(4)
}
const doCopy = (text) => {
  copy(text)
  showToast({ type: 'success', message: 'Link copied successfully, go ahead and share it!', className:'toast-success' })
}

onMounted(() => {
  if (userInfo.value) {
    getUserRole()
  }
  getWayList()
  getPayNape()
  getRemarkInfo()
})
</script>

<template>
  <section class="trade-box">
    <aside style="display: flex; align-items: center; padding: 0.04rem 0.16rem; background: rgb(255 255 255 / 20%); border-radius: 6px; margin: 0.66rem 15px 0rem;">
      <img v-if="payNavIndex == '1'" src="@/assets/img/03p/pay-nav01a.png" alt="" style="height: 0.13rem; padding: 0.02rem 0rem;">
      <img v-else src="@/assets/img/03p/pay-nav01.png" alt="" @click="payNavIndex = '1'" style="height: 0.13rem; padding: 0.02rem 0rem;">
      <span style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
      <img v-if="payNavIndex == '2'" src="@/assets/img/03p/pay-nav02a.png" alt="" style="height: 0.13rem; padding: 0.02rem 0rem;">
      <img v-else src="@/assets/img/03p/pay-nav02.png" alt="" @click="payNavIndex = '2'" style="height: 0.13rem; padding: 0.02rem 0rem;">
      <span style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
      <img v-if="payNavIndex == '3'" src="@/assets/img/03p/pay-nav03a.png" alt="" style="height: 0.13rem; padding: 0.02rem 0rem;">
      <img v-else src="@/assets/img/03p/pay-nav03.png" alt="" @click="payNavIndex = '3'" style="height: 0.13rem; padding: 0.02rem 0rem;">
    </aside>
    <section v-show="payNavIndex == '1'" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
      <aside style="display: flex; align-items: center; margin: 0.12rem 15px 0rem;">
        <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 18px; margin-right: 4px;">
        <span class="sz-box" style="width: 150px;">{{ userInfo.uname }}</span>
      </aside>
      <aside style="display: flex; align-items: center; margin: 0.08rem 15px;">
        <img src="@/assets/img/03p/qufu-icon.png" alt="" style="height: 18px; margin-right: 4px;">
        <span :class="activeRole ? 'sz-box' : 'sz-box2'" @click="showQufu = true" style="width: 150px;">{{ activeRole ? activeRole.dsname + '[' + activeRole.dsid + ']'  : '서버 선택' }}</span>
      </aside>
      <aside style="display: flex; justify-content: space-between; align-items: center; margin: 0rem 15px 0.2rem;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/id-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 70px;">{{ activeRole.drid }}</span>
        </aside>
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/name-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 70px;">{{ activeRole.drname }}</span>
        </aside>
      </aside>
      <section style="flex: 1; display: flex; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap; margin: 0px 5px; overflow: hidden; overflow-y: scroll;">
        <aside v-for="(nape, index) in payNapeList" :key="nape.coin" :class="nape.checked == 1 ? 'prod-item prod-item-act' : 'prod-item prod-item-no'" @click="checkPayNape(nape)">
          <aside class="prod-title text-sys2">{{ nape.desc }}</aside>
          <aside class="prod-zs">
            <img :src="flArr[index].flIcon" alt="" style="width: 60px; position: absolute; top: 0; right: -20px;">
            <img :src="nape.icon" alt="" style="height: 54px;">
            <span style="color: rgb(0, 104, 226); font-size: 12px;">{{ nape.title }}</span>
          </aside>
          <button class="prod-btn">{{ '₩' + nape.money }}</button>
        </aside>
      </section>
      <aside style="margin: 16px 0px 36px; display: flex; justify-content: center;">
        <img src="@/assets/img/03p/confirm.png" alt="" @click="goPay" style="width: 180px;height: 42px;">
      </aside>
    </section>
    <section v-show="payNavIndex == '2'" style="flex: 1; display: flex; flex-direction: column; align-items: center; overflow: hidden;">
      <aside style="margin-top: 0.12rem; display: flex; align-items: center; width: 356px;">
        <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 0.18rem; margin-left: 8px;">
        <span class="sz-box" style="width: 1.64rem; margin-left: 12px;">{{ userInfo.uname }}</span>
      </aside>
      <aside class="text-box" v-html="remarkInfo.REMARK"></aside>
      <aside style="width: 356px; display: flex; justify-content: flex-end; align-items: center; margin-top: 0.14rem;">
        <img @click="goCustomer" src="@/assets/img/04p/help02.png" alt="" style="height: 0.14rem;">
      </aside>
    </section>
    <section v-show="payNavIndex == '3'" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
      <aside style="display: flex; align-items: center; margin: 0.12rem 15px 0rem;">
        <!-- <span class="text-sys2">서버:</span> -->
        <span class="text-sys2">계정:</span>
        <span class="text-sys2" style="width: 150px;">{{ userInfo.uname }}</span>
      </aside>
      <aside style="display: flex; align-items: center; margin: 0.08rem 15px;">
        <img src="@/assets/img/03p/qufu-icon.png" alt="" style="height: 18px; margin-right: 4px;">
        <span :class="activeRole2 ? 'sz-box' : 'sz-box2'" @click="showQufu2 = true" style="width: 180px; position: relative;">
          {{ activeRole2 ? activeRole2.dsname + '[' + activeRole2.dsid + ']'  : '서버 선택' }}
          <span class="clear-btn" @click.stop="activeRole2 = ''">X</span>
        </span>
      </aside>
      <aside style="display: flex; justify-content: space-between; align-items: center; margin: 0rem 15px;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/id-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 70px;">{{ activeRole2.drid }}</span>
        </aside>
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/name-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 70px;">{{ activeRole2.drname }}</span>
        </aside>
      </aside>
      <aside style="display: flex; align-items: center; margin: 8px 15px 0rem;">
        <span class="text-sys2">총전일시: </span>
        <aside style="display: flex; align-items: center; font-size: 13px; background: #ffffff; border-radius: 6px; padding: 4px 6px; margin-left: 6px;">
          <span @click="showStartTime = true" :class="recordParams.stime ? 'time-text' : 'time-text-no'">{{ recordParams.stime ? recordParams.stime : '시작 시간' }}</span>-
          <span @click="showEndTime = true" :class="recordParams.etime ? 'time-text' : 'time-text-no'">{{ recordParams.etime ? recordParams.etime : '종료 시간' }}</span>
        </aside>
        <button @click="getAllPayment" class="btn-box">검색</button>
      </aside>
      <span style="color: rgb(90, 131, 208); font-size: 14px; margin: 8px 15px 0rem;">{{ '누적요금: ' + (tableData.SUMMONEY ? tableData.SUMMONEY : 0) }}</span>
      <section style="flex: 1; display: flex; flex-direction: column; align-items: center; margin: 12px 15px 36px;">
        <table v-if="tableData" style="background: rgb(255 255 255 / 60%);">
          <thead style="color: rgb(90, 131, 208); background: rgb(235, 235, 235);">
            <tr>
              <td>금액</td>
              <td>서버</td><!--区服-->
              <td>캐릭터</td><!--角色-->
              <td>결제수단</td><!--支付方式-->
              <td>총전일시</td><!--时间-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in tableData.data" :key="index">
              <td>{{ list.SHOWMONEY }}</td>
              <td>{{ list.DRNAME + '[' + list.DSID + ']' }}</td>
              <td>{{ list.DRNAME }}</td>
              <td>{{ list._PWAY }}</td>
              <td>{{ list.ATIME }}</td>
            </tr>
          </tbody>
        </table>
        <span v-else style="color: #999999; font-size: 14px;">해당하는 검색 결과가 없습니다.</span>
      </section>
    </section>
    <ElementPopup v-model:show="showStartTime" destroy-on-close round position="bottom">
      <ElementDatePicker
      v-model="currentDate"
      title="날짜 선택"
      :min-date="minDate"
      :max-date="maxDate"
      confirm-button-text="확인"
      cancel-button-text="취소"
      @confirm="confirmStart"
      @cancel="showStartTime = false"
      />
    </ElementPopup>
    <ElementPopup v-model:show="showEndTime" destroy-on-close round position="bottom">
      <ElementDatePicker
      v-model="currentDate"
      title="날짜 선택"
      :min-date="minDate"
      :max-date="maxDate"
      confirm-button-text="확인"
      cancel-button-text="취소"
      @confirm="confirmEnd"
      @cancel="showEndTime = false"
      />
    </ElementPopup>
    <ElementPopup v-model:show="showQufu" destroy-on-close round position="bottom">
      <ElementPicker
        title="서버 선택"
        confirm-button-text="확인"
        cancel-button-text="취소"
        :columns="roleData"
        :columns-field-names="{ value: 'dsid' }"
        @confirm="onConfirmRole"
        @cancel="showQufu = false"
        @change="onChangeRole"
      >
        <template #option="props">
          <aside style="color: rgb(94, 140, 196)">{{ props.dsname + '['+ props.dsid + ']' }}</aside>
        </template>
      </ElementPicker>
    </ElementPopup>
    <ElementPopup v-model:show="showPayWayPop" destroy-on-close round position="bottom">
      <ElementPicker
        title="결제수단"
        confirm-button-text="확인"
        cancel-button-text="취소"
        :columns="payWayList"
        :columns-field-names="{ value: 'pwayid' }"
        @confirm="createOrder"
        @cancel="showPayWayPop = false"
      >
        <template #option="props">
          <aside style="color: rgb(94, 140, 196); display: flex; align-items: center;">
            <img :src="props.icon" alt="" style="height: 36px;">
            <span style="display: block; width: 150px; text-align: center;">{{ props.desc }}</span>
          </aside>
        </template>
      </ElementPicker>
    </ElementPopup>
    <ElementPopup v-model:show="showQufu2" destroy-on-close round position="bottom">
      <ElementPicker
        title="서버 선택"
        confirm-button-text="확인"
        cancel-button-text="취소"
        :columns="roleData"
        :columns-field-names="{ value: 'dsid' }"
        @confirm="onConfirmRecordRole"
        @cancel="showQufu2 = false"
        @change="onChangeRole"
      >
        <template #option="props">
          <aside style="color: rgb(94, 140, 196)">{{ props.dsname + '['+ props.dsid + ']' }}</aside>
        </template>
      </ElementPicker>
    </ElementPopup>
  </section>
</template>

<style scoped>
.trade-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/03p/trade-bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
}
.sz-box {
  display: block;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 8px;
  font-size: 15px;
  color: rgb(94, 140, 196);
  padding: 3.5px 6px;
  background: #ffffff;
  height: 21px;
  line-height: 21px;
}
.sz-box2 {
  display: block;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 8px;
  font-size: 15px;
  color: #bcbcbc;
  padding: 3.5px 12px;
  background: #ffffff;
  height: 21px;
  line-height: 21px;
}
.prod-item {
  width: 29%;
  height: 156px;
  background: url('../../assets/img/03p/dw-bac.png') no-repeat;
  border-radius: 7px 0px 7px 0px;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
  background-size: 100% 100%;
  margin: 0px 4px 4px;
  /* padding: 1px 2px; */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.prod-item-no {
  border: 2px solid #ffffff;
}
.prod-item-act {
  border: 2px solid rgb(253, 206, 75);
}
.prod-item .prod-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.23rem;
  width: 100%;
  background: url('../../assets/img/03p/pay-title-bac.png') no-repeat;
  background-size: 100% 100%;
}
.prod-item .prod-zs {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.prod-item .prod-btn {
  background: url('../../assets/img/03p/pay-btn-bac.png') no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  font-style: italic;
  text-shadow: -1px -1px 0 rgb(0, 34, 77), 1px -1px 0 rgb(0, 34, 77), -1px 1px 0 rgb(0, 34, 77), 1px 1px 0 rgb(0, 34, 77);
  width: 94px;
  height: 32px;
  border: none;
  margin-bottom: 6px;
}
.text-sys2 {
  font-size: 16px;
  /* font-weight: bolder; */
  color: #ffffff;
  text-shadow: -1px -1px 0 rgb(67, 116, 167), 1px -1px 0 rgb(67, 116, 167), -1px 1px 0 rgb(67, 116, 167), 1px 1px 0 rgb(67, 116, 167);
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
table, thead, td {
  font-size: 14px;
  border: 1px solid rgb(146, 176, 206);
  border-collapse: collapse;
}
table {
  width: 100%;
  border-radius: 8px;
  max-height: 3.8rem;
  overflow-y: auto;
  display: block;
}
tbody {
  /* max-height: 3.4rem;
  overflow-y: auto;
  display: block; */
}
tr {
  height: 36px;
}
td {
  text-align: center;
  font-size: 11px;
  padding: 0px 2px;
}
.time-text {
  font-size: 13px;
  color: rgb(67, 116, 167);
  padding: 0px 6px;
}
.time-text-no {
  font-size: 13px;
  color: #cdcdcd;
  padding: 0px 6px;
}
.btn-box {
  background: rgb(29, 115, 180);
  border: none;
  border-radius: 6px;
  padding: 3px 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
}
.text-box {
  width: 332px;
  padding: 12px 16px;
  border-radius: 10px;
  background: rgb(255 255 255 / 50%);
  font-size: 13px;
  color: rgb(67, 116, 167);
  margin-top: 24px;
  line-height: 1.5;
  max-height: 4.4rem;
  overflow: hidden;
  overflow-y: scroll;
}
.clear-btn {
  position: absolute;
  top: 50%;
  right: 6px;
  font-size: 12px;
  transform: translateY(-50%);
  background: #dedede;
  color: #ffffff;
  display: block;
  width: 16px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
}
</style>
<style>
strong {
  font-size: 0.15rem;
  font-weight: bold;
}
p {
  color: red;
  display: contents;
}
</style>